/* eslint-disable react/no-array-index-key */
import React, { useState, useRef } from 'react';
import CTA from 'react-scale/components/elements/cta';
import Link from 'next/link';

import Form from 'react-scale/components/elements/hubspot-form';
import Modal from 'react-scale/components/tailwind/Modal';

const Content = ({ box }) => (
  <div
    className="flex flex-col transition-colors duration-500 ease-in-out border rounded-lg border-neutral-800 hover:border-transparent"
    style={{
      background:
        'linear-gradient(#000, #000) content-box, linear-gradient(#7B8FDD, #262626) border-box'
    }}
  >
    <header className="p-8 min-h-[256px] relative overflow-hidden">
      <div className="absolute inset-0 bottom-0 h-64 rounded-sm w-96">
        <div className="w-24 h-20 left-[206.56px] bottom-[-50px] absolute origin-top-left rotate-180 bg-scale-mauve rounded-full blur-3xl" />
        <div className="w-32 h-40 left-[329.92px] bottom-[-160px] absolute origin-top-left rotate-180 bg-[#6A5DF9]/50 bg-opacity-50 rounded-full blur-3xl" />
      </div>
      <div className="flex flex-col gap-[10px] relative">
        <h2 className="text-3xl font-aeonik">{box.title}</h2>
        <p className="text-base">{box.subtitle}</p>
      </div>
    </header>
    <main className="p-8 border-t border-b border-neutral-800 min-h-[273px] flex-1">
      <ul className="flex flex-col gap-6">
        {box.bullets?.map((bullet, i) => (
          <li key={i} className="flex items-start gap-3 text-lg">
            <picture className="relative top-1">
              <svg
                width="16"
                height="16"
                viewBox="0 0 16 16"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <rect width="16" height="16" rx="8" fill="#404040" />
                <path
                  fillRule="evenodd"
                  clipRule="evenodd"
                  d="M11.3977 4.9271L6.62434 9.53377L5.35767 8.18043C5.12434 7.96043 4.75767 7.9471 4.491 8.13376C4.231 8.3271 4.15767 8.6671 4.31767 8.94043L5.81767 11.3804C5.96434 11.6071 6.21767 11.7471 6.50434 11.7471C6.77767 11.7471 7.03767 11.6071 7.18434 11.3804C7.42434 11.0671 12.0043 5.6071 12.0043 5.6071C12.6043 4.99376 11.8777 4.45377 11.3977 4.92043V4.9271Z"
                  fill="url(#paint0_linear_15284_12682)"
                />
                <defs>
                  <linearGradient
                    id="paint0_linear_15284_12682"
                    x1="4.2334"
                    y1="8.24409"
                    x2="12.2319"
                    y2="8.24409"
                    gradientUnits="userSpaceOnUse"
                  >
                    <stop stopColor="#C88BC4" />
                    <stop offset="0.9987" stopColor="white" />
                  </linearGradient>
                </defs>
              </svg>
            </picture>
            <p className="flex-1 text-base text-neutral-300">{bullet.text}</p>
          </li>
        ))}
      </ul>
    </main>
    <div className="flex justify-center p-8 pointer-events-none">
      <CTA cta={box.cta} size={box.size} fullWidth center={false} />
    </div>
  </div>
);

const Pricing = ({ boxes }) => {
  const [showModal, setShowModal] = useState(false);
  const formWrapperRef = useRef();

  const toggleModal = () => {
    setShowModal(!showModal);
  };
  return (
    <div className="grid grid-flow-row gap-8 lg:grid-cols-3 auto-rows-fr">
      {boxes?.map((box, index) => (
        <>
          {box.cta.buttons[0]?.href && (
            <Link href={box.cta.buttons[0]?.href}>
              <Content box={box} key={index} />
            </Link>
          )}
          {box.cta.hubspotModal?.formId && (
            <>
              <a className="cursor-pointer" onClick={toggleModal}>
                <Content box={box} key={index} />
              </a>
              <Modal
                title={box.cta.hubspotModal.label}
                isShowing={showModal}
                hide={() => setShowModal(false)}
                contentClassName="max-w-lg"
              >
                <div ref={formWrapperRef}>
                  <Form portalId="4823527" formId={box.cta?.hubspotModal?.formId} />
                </div>
              </Modal>
            </>
          )}
        </>
      ))}
    </div>
  );
};

export default Pricing;
